export const FAQ = [
  {
    en: 'What should I do if my waste wasn’t collected on time?',
    ru: 'Что делать, если отходы не были вывезены вовремя?',
    et: 'Mida ma peaksin tegema, kui mu jäätmeid ei kogutud õigel ajal?',
  },
  {
    en: 'How do I update my contact information?',
    ru: 'Как обновить мою контактную информацию?',
    et: 'Kuidas oma kontaktandmeid värskendada?',
  },
  {
    en: 'How do I change my waste management plan?',
    ru: 'Как изменить план управления отходами?',
    et: 'Kuidas ma saan oma jäätmekava muuta?',
  },
  {
    en: 'How do I request a recycling bin?',
    ru: 'Как мне запросить контейнер для переработки отходов?',
    et: 'Kuidas taotleda prügikasti?',
  },
  {
    en: 'How do I track the status of my service requests?',
    ru: 'Как отслеживать статус моих заявок на обслуживание?',
    et: 'Kuidas jälgida oma teenusetaotluste olekut?',
  },
];
